/**
 * AuditorPage — la página suelta del auditor, en `/auditor`.
 *
 * Existe para poder **probarlo en staging contra Google de verdad sin meterlo
 * en la landing**. El banco de pruebas local (`auditor-preview.html`) no sirve
 * para eso: está gitignorado y excluido del build a propósito, así que nunca
 * llega a un servidor.
 *
 * No está enlazada desde ningún sitio: ni nav, ni footer, ni sitemap. Se entra
 * escribiendo la URL.
 *
 * **En producción es inofensiva aunque exista.** Con `PUBLIC_AUDIT_ENABLED` en
 * `False` —el default— `AuditorSeo` pregunta por el interruptor, recibe que no,
 * y no pinta nada: esta página queda en blanco. No hay que acordarse de
 * revertirla para desplegar sin riesgo, que es justo lo que la hace útil.
 *
 * Deliberadamente sin `LandingNav` ni `LandingFooter`: lo que se quiere mirar
 * aquí es el componente, y montarlo desnudo obliga a que siga siendo
 * autocontenido. El día que necesite algo del resto de la página, se verá aquí
 * primero.
 */
import AuditorSeo from './AuditorSeo';

export default function AuditorPage() {
  return (
    <div className="landing-v2 min-h-screen w-full bg-white py-16">
      <AuditorSeo />
    </div>
  );
}
